import { useViewport } from "@/design-system/viewport.tsx"

// beacon: one answer to "is this a phone?" for the whole web app: the design system's `compact`
// (below 1024px), right on the first render. Upstream asked for below 768px, a render late.
export function useIsMobile() {
  return useViewport().compact
}
